import { FormValidator, ValidationRules } from 'src/utils/FormValidator';
import { ERROR_MESSAGES, VALIDATION_PATTERNS } from 'src/contstant/commonLabels';
import { parseAssignees } from 'src/utils/generalUtils';

export const AuditValidationPaths = {
  NAME: {
    path: 'name',
    message: 'Error: Please enter the audit name.',
  },
  LOCATION: {
    path: 'location',
    message: 'Error: Please select Location for Audit',
  },
  DIVISION: {
    path: 'division',
    message: 'Error: Please select the division.',
  },
  AUDIT_TYPE: {
    path: 'auditType',
    message: 'Error: Please select the audit type.',
  },
  START_DATE: {
    path: 'startDate',
    message: 'Error: Please enter audit start date.',
  },
  EXPIRY_DATE: {
    path: 'expiryDate',
    message: 'Error: Please enter audit expiry date.',
  },
  TEMPLATE_ID: {
    path: 'templateId',
    message: 'Error: Please select a template.',
  },
  ASSIGNEE: {
    path: 'assignees',
    message: 'Error: Please enter at least one assignee.',
  },
} as const;

export const AuditValidator = (): FormValidator => {
  const validator = new FormValidator();

  validator.addRule(
    AuditValidationPaths.NAME.path,
    ValidationRules.required,
    AuditValidationPaths.NAME.message,
  );
  validator.addRule(
    AuditValidationPaths.LOCATION.path,
    ValidationRules.required,
    AuditValidationPaths.LOCATION.message,
  );
  validator.addRule(
    AuditValidationPaths.DIVISION.path,
    ValidationRules.required,
    AuditValidationPaths.DIVISION.message,
  );
  validator.addRule(
    AuditValidationPaths.AUDIT_TYPE.path,
    ValidationRules.required,
    AuditValidationPaths.AUDIT_TYPE.message,
  );
  validator.addRule(
    AuditValidationPaths.START_DATE.path,
    ValidationRules.required,
    AuditValidationPaths.START_DATE.message,
  );
  validator.addRule(
    AuditValidationPaths.EXPIRY_DATE.path,
    ValidationRules.required,
    AuditValidationPaths.EXPIRY_DATE.message,
  );
  validator.addRule(
    AuditValidationPaths.TEMPLATE_ID.path,
    ValidationRules.required,
    AuditValidationPaths.TEMPLATE_ID.message,
  );
  validator.addRule(
    AuditValidationPaths.ASSIGNEE.path,
    ValidationRules.required,
    AuditValidationPaths.ASSIGNEE.message,
  );
  validator.addRule(
    AuditValidationPaths.ASSIGNEE.path,
    (value: string) => {
      const aliases = parseAssignees(value);
      return (
        aliases.length > 0 &&
        aliases.every((alias) => VALIDATION_PATTERNS.ASSIGNEE_ALIAS.test(alias))
      );
    },
    `Error: ${ERROR_MESSAGES.ASSIGNEE_AT_SYMBOL}`,
  );

  return validator;
};
